'use client'

import { ContentSwitcher } from '@src/components/ContentSwitcher/ContentSwitcher'
import { useLocale } from '@src/i18n/LocaleProvider'

import type { LocaleContentSwitcherProps } from './LocaleContentSwitcher.props'

export const LocaleContentSwitcher = (props: LocaleContentSwitcherProps) => {
  const { items = [], builderBlock, previewMode = false } = props
  const { locale } = useLocale()
  const defaultIndex = items.findIndex((item) => item.matchUrlLocale === locale.path)

  return (
    <ContentSwitcher
      items={items.map((item) => ({
        contentBottom: item.contentBottom,
        contentTop: item.contentTop,
        title: item.title,
      }))}
      builderBlock={builderBlock}
      previewMode={previewMode}
      defaultIndex={defaultIndex > -1 ? defaultIndex : 0}
    />
  )
}
